<div *ngIf="mediaHasError" class="placeholder-image-wrapper">
  <figure>
    <img *inView [src]="IMAGE_PLACEHOLDER" title="placeholder-image" />
  </figure>
  <ng-content></ng-content>
</div>
<div *ngIf="!mediaHasError && isVideo" class="video-wrapper">
  <figure>
    <video *inView autoplay loop playsinline muted>
      <source
        [src]="getMediaSource()"
        (onload)="onMediaHasLoaded()"
        (error)="onMediaHasError()"
      />
      Your browser does not support the video tag.
    </video>
  </figure>
  <ng-content></ng-content>
</div>
<div *ngIf="!mediaHasError && isImage" class="image-wrapper">
  <figure>
    <img
      *inView
      [src]="getMediaSource()"
      title="image"
      (onload)="onMediaHasLoaded()"
      (error)="onMediaHasError()"
    />
  </figure>
  <ng-content></ng-content>
</div>
<div class="background-loader">
  <rr-overlay-spinner [spinnerStatus]="spinnerStatus"></rr-overlay-spinner>
</div>
